import Image from 'next/image';
import Link from 'next/link';

import ArrowIcon from '@/fo/icons/base/icons/arrow24.svg';
import ChevronIcon from '@/fo/icons/base/icons/chevron24.svg';
import { UiKitLabelBase } from '@/fo/ui/kit/label/base';
import { UiKitLabelBrand } from '@/fo/ui/kit/label/brand';
import { UiKitPriceBase } from '@/fo/ui/kit/price/base';
import { ButtonBuy } from '@/fo/ui/product/button/buy';

import { Product } from '../types';

import { styles } from './UiProductTileMedium.styles';

export interface UiProductTileMediumProps {
  product: Product;
  type?: 'buy' | 'anchor';
  onClick?: (id: number | string) => void;
  onAddToCart?: React.HTMLAttributes<HTMLButtonElement>['onClick'];
  isInCart?: boolean;
}

export function UiProductTileMedium({
  type = 'buy',
  product,
  onClick,
  onAddToCart,
  isInCart = false,
  ...props
}: UiProductTileMediumProps) {
  const slots = styles();

  const {
    id,
    stock,
    link,
    image,
    alt,
    title,
    subtitle,
    labels,
    brandLabels,
    prices
  } = product;

  return (
    <div
      className={slots.base()}
      onClick={() => onClick?.(id)}
      {...props}
    >
      {image && (
        <Image
          className={slots.image()}
          src={image}
          alt={alt || title}
          width={110}
          height={110}
        />
      )}

      <div className={slots.contentWrapper()}>
        {link && (
          <Link
            className={slots.link()}
            href={link}
          />
        )}
        {(labels || brandLabels) && (
          <div className={slots.labelContainer()}>
            {labels &&
              labels.map((label, index) => (
                <UiKitLabelBase
                  key={index}
                  customColor={label.color}
                >
                  {label.name}
                </UiKitLabelBase>
              ))}
            {brandLabels &&
              brandLabels.map(({ color, name, url }) => {
                return (
                  <UiKitLabelBrand
                    key={name.trim()}
                    color={color}
                    url={url}
                  >
                    {name}
                  </UiKitLabelBrand>
                );
              })}
          </div>
        )}

        <div
          className={slots.title()}
          dangerouslySetInnerHTML={{ __html: title }}
        />

        {subtitle && (
          <div
            className={slots.subtitle()}
            dangerouslySetInnerHTML={{ __html: subtitle }}
            suppressHydrationWarning
          />
        )}

        <div className={slots.priceContainer()}>
          {prices && prices.price !== null && prices.price > 0 && (
            <>
              <UiKitPriceBase
                value={prices.price}
                oldValue={prices.oldPrice}
                classNameValue={slots.price()}
                classNameOldValue={slots.oldPrice()}
              />
              {type === 'buy' && (
                <ButtonBuy
                  className={slots.buyButton()}
                  isInCart={isInCart}
                  onClick={onAddToCart}
                  disabled={Boolean(stock && stock === 'OUT_OF_STOCK')}
                />
              )}
            </>
          )}

          {type === 'anchor' && <ArrowIcon className={slots.arrow()} />}
        </div>
      </div>

      {type === 'anchor' && <ChevronIcon className={slots.chevron()} />}
    </div>
  );
}
